import { render } from "./ResidentialApartmentsList.vue?vue&type=template&id=01ef3f19&scoped=true"
import script from "./ResidentialApartmentsList.vue?vue&type=script&lang=js"
export * from "./ResidentialApartmentsList.vue?vue&type=script&lang=js"

import "./ResidentialApartmentsList.vue?vue&type=style&index=0&id=01ef3f19&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ef3f19"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QIcon,QDialog,QCard,QCardSection,QCardActions});
